import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils';
import categoryService from '@/services/billing/expenses/categoryService';

const toExpenseCategoryOptions = (rows) =>
    rows.map(tax => ({
        label: tax.category_name,
        value: tax.id.toString(),
        id: tax.id.toString(),
        original: tax,
    }));

const useExpenseCategoryOptions = ({
    defaultPageSize = 20,
} = {}) => {
    const loadOptions = useCallback(
        async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
            try {
                const response = await categoryService.getAllCategory({
                    page,
                    pageSize,
                    search,
                });

                const status =
                    typeof response?.status === 'boolean' ? response.status : true;
                if (!status) return { options: [], hasMore: false };

                let rows = getRows(response);
                const options = toExpenseCategoryOptions(rows);

                const totalRecords = getTotalRecords(response);
                const hasMore =
                    typeof totalRecords === 'number'
                        ? page * pageSize < totalRecords
                        : options.length === pageSize;

                return { options, hasMore };
            } catch (error) {
                console.error('Error', error);
                toast.error('Failed to fetch Tax.', {
                    description: 'Please try again.',
                });
                return { options: [], hasMore: false };
            }
        },
        [defaultPageSize]
    );

    return loadOptions;
};

export { useExpenseCategoryOptions };
